import { SlashTiming } from '@ui-components/design-tokens';
import { CookieConsentContext } from 'app/components/CookieConsent/CookieConsentProvider';
import { CookieConsentType } from 'app/components/CookieConsent/CookieConsentType';
import ErrorBoundary from 'app/components/ErrorHandler/ErrorBoundary';
import SurveyContainer from 'app/components/Survey/SurveyContainer';
import { useRouter } from 'next/router';
import React, { useContext, useEffect, useState } from 'react';
import env from '../../env';
import { ReactHelmetPlayApplication } from '../ReactHelmet/ReactHelmet';
import Footer from '../Footer/Footer';
import Header from '../Header/Header';
import ImportantMessages from '../ImportantMessages/ImportantMessagesContainer';
import { A11yAnnouncer, MainContent, ReactBase } from './BaseLayout.styles';
import GlobalStyles from './GlobalStyles';

const BaseLayout = ({ children }) => {
    const router = useRouter();
    const videoModalOpen = Boolean(router.query.modalId);

    const [hideOverflow, setHideOverflow] = useState(false);

    const { isOptedIn, showConsentModal } = useContext(CookieConsentContext);

    useEffect(() => {
        if (videoModalOpen) {
            const handler = setTimeout(() => {
                setHideOverflow(true);
            }, SlashTiming * 0.7);
            return () => {
                clearTimeout(handler);
            };
        }
        setHideOverflow(false);

        return () => {};
    }, [videoModalOpen]);
    return (
        <>
            <GlobalStyles
                // @ts-ignore
                hideOverflow={hideOverflow || showConsentModal.visible}
            />
            {typeof document !== 'undefined' && isOptedIn(CookieConsentType.STATISTICS) && (
                <SurveyContainer />
            )}
            <ReactBase
                videoModalOpen={videoModalOpen}
                cookieConsentVisible={showConsentModal.visible}
                aria-hidden={videoModalOpen || showConsentModal.visible}
                hide={hideOverflow}
            >
                <ReactHelmetPlayApplication router={router} />
                <A11yAnnouncer id="play_a11y-announcer" aria-live="assertive" />
                <div id="fb-root" data-appid={env.FB_APP_ID} />
                <div className="play_root-container">
                    <ImportantMessages key={router.asPath} />
                    <div className="play_root">
                        <Header />

                        <ErrorBoundary>
                            {/*
                                // @ts-ignore */}
                            <MainContent id="play_main-content" tabIndex="-1">
                                {children}
                            </MainContent>
                        </ErrorBoundary>

                        <Footer />
                    </div>
                </div>
            </ReactBase>
        </>
    );
};

export const BaseLayoutWrapper = ({ children, videoModalOpen }) => (
    <ReactBase videoModalOpen={videoModalOpen} aria-hidden={videoModalOpen}>
        {children}
    </ReactBase>
);

export default BaseLayout;
